import * as React from "react";
const SvgFiRrUserPolice = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.124 23.992c-.614.046-1.053-.362-1.116-.868-.258-2.067-1.192-4.175-2.271-5.123L12.76 22.65c-.381.445-1.141.445-1.521 0l-4.02-4.705c-1.035 1.005-1.97 3.112-2.228 5.18a1 1 0 1 1-1.984-.248c.245-1.968 1.162-4.818 2.936-6.377a2.013 2.013 0 0 1 2.744.09L12 20.46l3.259-3.815c.8-.804 2.006-.845 2.798-.146 1.773 1.56 2.69 4.41 2.936 6.377.068.548-.318 1.075-.868 1.116zM4 3.65c0-.976.648-1.834 1.587-2.1L10.302.21a7 7 0 0 1 3.396 0l4.715 1.34a2.185 2.185 0 0 1 .38 4.054L18 6v2c0 3.31-2.691 6-6 6s-6-2.69-6-6V6l-.793-.396A2.18 2.18 0 0 1 4 3.65m12 3.965c-.976.206-2.31.385-4 .385-1.691 0-3.024-.179-4-.385V8c0 2.206 1.794 4 4 4s4-1.794 4-4zm-6-3.55c0 1.331 1.552 2.211 2 2.435.448-.18 2-.922 2-2.435v-1.45a.44.44 0 0 0-.304-.42L12 1.631l-1.696.562a.44.44 0 0 0-.304.421z"
    />
  </svg>
);
export default SvgFiRrUserPolice;
